import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { forwardRef, memo } from "react";
import { Chip, chipClasses } from "./Chip";
import { useDefaultProps } from "../providers/utils/defaultProps";
import { mergeSx } from "../system";
export const avatarChipClasses = {
    root: "MinervaAvatarChip-root",
};
export const AvatarChip = memo(forwardRef((props, ref) => {
    const { density = "comfortable", className, sx, ...rest } = useDefaultProps({ component: "AvatarChip", props });
    return (_jsx(Chip, { ref: ref, className: clsx([className, avatarChipClasses.root]), density: density, sx: mergeSx({
            borderRadius: (theme) => theme.radius.full,
            [`&.${chipClasses.selected}`]: {
                paddingRight: density === "comfortable" ? 4 : density === "dense" ? 3 : 0,
            },
        }, sx), ...rest }));
}));
//# sourceMappingURL=AvatarChip.js.map